function loadGoogleTagManager(w, d, s, l, i, k, e) {
  w[l] = w[l] || [];
  w[l].push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });
  var f = d.getElementsByTagName(s)[0];
  var j = d.createElement(s),
    dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;

  if (e) {
    j.src =
      'https://www.googletagmanager.com/gtm.js?id=' +
      i +
      dl +
      '&gtm_auth=' +
      k +
      '&gtm_preview=' +
      e +
      '&gtm_cookies_win=x';
  } else {
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  }

  f.parentNode.insertBefore(j, f);
}
